import { useEffect } from 'react';
import ServicesHeroFr from './components/ServicesHeroFr';
import ServicesDetailFr from './components/ServicesDetailFr';
import ServicesCTAFr from './components/ServicesCTAFr';

const SERVICES_SCHEMA_FR = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/services#webpage`,
      url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/services`,
      name: 'Nos Services | MAX-Sourcing — Approvisionnement mondial & Réglementaire',
      description:
        'Découvrez la gamme complète de services de MAX-Sourcing : approvisionnement pharmaceutique stratégique, conformité réglementaire, liaison exécutive et logistique en Amérique du Nord, Europe, Chine et Inde.',
      inLanguage: 'fr',
      isPartOf: {
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#website`,
      },
      about: {
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#organization`,
      },
      dateModified: '2026-04-07',
      translationOfWork: {
        '@type': 'WebPage',
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/services#webpage`,
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/services`,
        inLanguage: 'en',
      },
      workTranslation: {
        '@type': 'WebPage',
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/services#webpage`,
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/services`,
        inLanguage: 'en',
      },
    },
    {
      '@type': 'Service',
      '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/services#service`,
      name: 'Services mondiaux d\'approvisionnement pharmaceutique et de produits chimiques fins',
      provider: {
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#organization`,
      },
      serviceType: 'Approvisionnement pharmaceutique',
      areaServed: [
        { '@type': 'Country', name: 'Canada' },
        { '@type': 'Country', name: 'États-Unis' },
        { '@type': 'Country', name: 'Royaume-Uni' },
        { '@type': 'Country', name: 'Chine' },
        { '@type': 'Country', name: 'Inde' },
      ],
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Catalogue de services MAX-Sourcing',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Approvisionnement stratégique',
              description: 'Approvisionnement mondial en IPA pharmaceutiques et produits chimiques fins avec vérification de conformité BPF.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Conformité réglementaire',
              description: 'Soutien réglementaire complet pour les chaînes d\'approvisionnement pharmaceutiques et chimiques.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Liaison exécutive',
              description: 'Liaison exécutive bilingue entre les clients nord-américains et les fabricants asiatiques.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Logistique & Contrats',
              description: 'Gestion de la logistique de la chaîne d\'approvisionnement et négociation de contrats pour l\'approvisionnement mondial en produits chimiques.',
            },
          },
        ],
      },
    },
  ],
};

export default function ServicesPageFr() {
  useEffect(() => {
    document.title = 'Nos Services | MAX-Sourcing — Approvisionnement mondial & Réglementaire';
    const id = 'schema-services-fr';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(SERVICES_SCHEMA_FR);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ServicesHeroFr />
      <ServicesDetailFr />
      <ServicesCTAFr />
    </div>
  );
}
